export default {
  weekday_0: "Mo",
  weekday_1: "Tu",
  weekday_2: "We",
  weekday_3: "Th",
  weekday_4: "Fr",
  weekday_5: "Sa",
  weekday_6: "Su",
  weekday_other: "Backup",
  shortcut_title: "Shortcuts",
  shortcut_feature: "Function",
  shortcut_shortcut: "Shortcut",
  shortcut_TODO_ITEM: "Item",
  shortcut_INCREMENT: "Increase",
  shortcut_DECREMENT: "Decrease",
  shortcut_MOVE_UP: "Move up",
  shortcut_MOVE_DOWN: "Move down",
  shortcut_EDIT: "Edit",
  shortcut_EDIT_VIEW: "Edit View",
  shortcut_FOCUS_INPUT: "New Entry",
  shortcut_PREVIOUS_LIST: "Previous List",
  shortcut_NEXT_LIST: "Next List",
  shortcut_SHOPPING_MODE: "Change to Shopping View",
  shortcut_SHOPPING_VIEW: "Shopping View",
  shortcut_EDIT_MODE: "Change to Edit View",
  drawer_version: "Listhero Version",
  drawer_accountid: "Account ID",
  drawer_copysync: "Copy Sync Link",
  drawer_copysync_description: "This link grants access to your account",
  drawer_copysyncqr: "Copy Sync Link as QR Code",
  drawer_scanqr: "Scan Sync QR Code",
  drawer_log: "Log",
  drawer_resync: "Synchronize",
  drawer_newaccount: "Create New Account",
  drawer_newaccount_description:
    "Your current account is lost without sync link",
  drawer_shortcuts: "Shortcuts",
  drawer_newaccount_dialog:
    "Do you really want to discard your current account?",
  list_shoppingview_label: "Shopping View",
  list_editview_label: "Edit",
  list_entries: "Entries",
  list_newentry: "New Entry",
  list_noentries: "All done!",
  copysyncqr_title: "Sync Link",
  copysyncqr_explanation: "This link grants access to your account",
  recentused_title: "Recent Entries",
  recentused_search_placeholder: "Filter entries",
  recentused_sort_chronological: "Sort chronologically",
  recentused_sort_alphabetical: "Sort alphabetically",
  scanqr_title: "Scan Sync Link",
  scanqr_scan: "Scan a sync qr code here",
  scanqr_paste: "or paste a link here",
  login_title: "Account Synchronization",
  login_error: "The login was not successful",
  login_servererror: "Check the server password",
  login_login: "Login",
  login_createaccount: "Create Account",
  login_overwritewarning: `Your current account will be overwritten by the synchronization.
  If you want to keep your account, save your sync link first.`,
  login_overwrite: "Synchronize",
  login_copysynclink: "Copy Sync Link for Current Account",
  lists_menu_label: "Menu",
  lists_title: "All Lists",
  lists_addlist_label: "Add List",
  lists_welcome: `
    You don't have any lists yet.
    Tap "+" on the top right to add a list

    Entries can be synced across multiple devices.
    Open the mneu on the top left to copy your sync code.
  `,
  lists_entries: "Entries",
  listmenu_rename: "Rename",
  listmenu_clear: "Clear",
  listmenu_remove: "Delete",
  listmenu_toweekplan: "To Week List",
  listmenu_tolist: "To Normal List",
  listmenu_copy: "Copy",
  listmenu_log: "Show Log",
  confirmdialog_cancel: "Cancel",
  confirmdialog_confirm: "OK",
  itemmenu_moveto_back: "Back",
  itemmenu_tobottom: "Move to Bottom",
  itemmenu_done: "Done",
  itemmenu_moveto: "Move to List",
  namedialog_cancel: "Cancel",
  namedialog_confirm: "Save",
  serverpassword_label: "Server Password",
  snackbar_listremove_label: "deleted",
  snackbar_listremove_action: "Undo",
  log_title: "Log",
  log_placeholder: "Filter list name",
  log_loading: "Loading...",
  log_item_ADD_LIST: "Added list {{ list }}",
  log_item_ADD_ITEM: "Added item {{ item }} to {{ list }}",
  log_item_REMOVE_ITEM: "Removed item {{ item }} from {{ list }}",
  log_item_REMOVE_RECENTLY_USED_ITEM: "Removed item {{ item }} from recently used items of {{ list }}",
  log_item_EDIT_ITEM: "Changed item {{ oldItem }} to {{ item }} on {{ list }}",
  log_item_REMOVE_LIST: "Removed list {{ list }}",
  log_item_MOVE_ITEM_TO_LIST: "Moved item {{ item }} from {{ oldList }} to {{ list }}",
};



// WEBPACK FOOTER //
// ./src/translations/en.js